import React from 'react';

const Leaderboard = ({ leaderboard }) => {
  const getMedalEmoji = (index) => {
    if (index === 0) return '🥇';
    if (index === 1) return '🥈';
    if (index === 2) return '🥉';
    return `${index + 1}.`;
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
        🏆 Žebříček
      </h2>
      <div className="space-y-3">
        {leaderboard.map((player, index) => (
          <div
            key={player.sessionId}
            className={`flex items-center justify-between p-4 rounded-lg ${
              index < 3
                ? 'bg-gradient-to-r from-yellow-100 to-yellow-50'
                : 'bg-gray-50'
            }`}
          >
            <div className="flex items-center gap-4">
              <div className="text-2xl font-bold w-12 text-center">
                {getMedalEmoji(index)}
              </div>
              <div>
                <div className="font-semibold text-gray-800">
                  {player.name}
                </div>
              </div>
            </div>
            <div className="text-2xl font-bold text-primary-600">
              {player.score.toFixed(1)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leaderboard;
